__turbopack_context__.v({
  "container": "ButtonClose-module__t0garq__container",
  "fadeInItems": "ButtonClose-module__t0garq__fadeInItems",
  "spacing--lg": "ButtonClose-module__t0garq__spacing--lg",
  "spacing--md": "ButtonClose-module__t0garq__spacing--md",
  "spacing--sm": "ButtonClose-module__t0garq__spacing--sm",
  "spacing--xl": "ButtonClose-module__t0garq__spacing--xl",
  "spacing--xs": "ButtonClose-module__t0garq__spacing--xs",
  "spacing--xxl": "ButtonClose-module__t0garq__spacing--xxl",
  "spacing--xxs": "ButtonClose-module__t0garq__spacing--xxs",
  "spacing--xxxl": "ButtonClose-module__t0garq__spacing--xxxl",
  "spacing--xxxs": "ButtonClose-module__t0garq__spacing--xxxs",
});
